export default [
  {
    text: 'Project Description',
    value: 'description',
    sortable: true,
    order: 2,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Project Manager',
    value: 'projectManager',
    sortable: true,
    order: 3,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Start Date',
    value: 'startDate',
    sortable: true,
    order: 4,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Finish Date',
    value: 'finishDate',
    sortable: true,
    order: 5,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Actions',
    value: 'actions',
    width: '60px',
    sortable: false,
    order: 6,
    hidable: true,
    hidden: false,
  },
];
